/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'
import { withRouter } from 'react-router';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { TabMenu } from 'primereact/tabmenu';

import { SET_VALUES_PROFILE } from '@constants/actionType';

import { LANGUAGE_DEFAULT } from '@constants/general';


import store from '@store';

class GeneralProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      activeTabIndex: 0,
      errors: []
    }
    this.initialValuesForm = {
      name: '',
      // description: '',
    };
  }

  componentDidMount() {
    const { _general, keysLenguages } = this.props;
    if (_general) {
      this.setState({
        ..._general
      });
    } else {
      keysLenguages.map((item) =>
        this.setState({ [item]: { ...this.initialValuesForm } })
      );
    }
    this.setState({ loadingPage: false });
  }

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success, t } = this.props;
    await this.setValuesToStateGlobal();
    success();
  };

  setValuesToStateGlobal = async () => {
    const { keysLenguages } = this.props;

    const getValues = keysLenguages.reduce((accum, item) => {
      accum[item] = this.state[item];
      return accum;
    }, {});

    await store.dispatch({
      type: SET_VALUES_PROFILE,
      payload: {
        general: getValues,
      }
    });
    return true
  };

  validateFields = async () => {
    const { t } = this.props
    const { name } = this.state[LANGUAGE_DEFAULT]
    let errors = {}
    if (!name) errors = {...errors, [`${LANGUAGE_DEFAULT}-name`]: `${t('Nombre')} ${t('es requerido')}`}
    this.setState({errors})
    return errors
  }



  render() {
    const { t, btnSubmitLoading, onBack, keysLenguages, itemsTabsLenguages, history } =this.props;
    const { loadingPage, errors, activeTabIndex } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
        <>
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Nombre', {lng: prefixLenguage })}
            </label>
            <InputText
              name={`${prefixLenguage}-name`}
              type="text"
              value={this.state[prefixLenguage].name}
              onChange={this.onChange}
              autoFocus
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-name`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-name`)}
          </div>
        </>
      );
    };

    if (loadingPage) return true;
    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12">
              {itemsTabsLenguages && (
                <TabMenu
                  model={itemsTabsLenguages}
                  activeIndex={activeTabIndex}
                  onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                />
              )}
            </div>
            {renderByTabLenguage()}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Cancelar')}
                type="button"
                className="p-button-secondary"
                onClick={() => history.push('/profiles')}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  _general: state.profile.general
});

export default withRouter(compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(GeneralProfile));
